import { Component, OnInit, Input, Output } from "@angular/core";
import { Router } from "@angular/router";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { AuthService } from "../../service/auth.service";
import { GeneralService } from "../../service/general.service";


@Component({
    selector: "info-dialog",
    templateUrl: "../../../html/incs/info-dialog.html"
})
export class InfoDialog implements OnInit {
    public infoTitle:string = null!;
    public infoMessage:string = null!;

    constructor(public dialogRef: MatDialogRef<InfoDialog>,
        private router: Router,
        private authService: AuthService,
        private generalService: GeneralService
    ) {}

    ngOnInit(): void {
    }

    closeDialog() {
      this.dialogRef.close(null!);
    }
}